import React from "react";
import { attorneys } from "../mock";
import { Linkedin, Mail } from "lucide-react";

function initials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

// Deterministic gradient per attorney based on name length
function paletteFor(id) {
  const palettes = [
    ["#0e1b34", "#14264a"],
    ["#14264a", "#0e1b34"],
    ["#1a3057", "#0e1b34"],
    ["#0e1b34", "#1a3057"],
  ];
  return palettes[id % palettes.length];
}

export default function AttorneysSection() {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#b28e42] uppercase tracking-[0.35em] text-xs font-semibold">
            Meet the Team
          </span>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#0e1b34] mt-3 gold-underline center">
            Our Attorneys / Associates
          </h2>
          <p className="text-neutral-600 mt-6">
            A team of dedicated, experienced and technology-driven legal professionals ready to serve you.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {attorneys.map((a) => {
            const [c1, c2] = paletteFor(a.id);
            return (
              <div
                key={a.id}
                className="attorney-card group bg-white rounded-sm overflow-hidden border border-neutral-200"
              >
                <div
                  className="relative overflow-hidden aspect-[3/4] flex items-center justify-center"
                  style={{
                    background: `linear-gradient(160deg, ${c1} 0%, ${c2} 100%)`,
                  }}
                >
                  {/* Decorative ring */}
                  <div className="absolute inset-0 pointer-events-none opacity-40" style={{
                    backgroundImage:
                      "radial-gradient(circle at 20% 15%, rgba(201,169,97,0.35) 0, transparent 45%), radial-gradient(circle at 85% 90%, rgba(201,169,97,0.25) 0, transparent 40%)",
                  }} />
                  <div className="relative z-10 text-center px-5">
                    <div className="w-24 h-24 mx-auto rounded-full border-2 border-[#c9a961] bg-[#0a1428]/40 flex items-center justify-center backdrop-blur-sm">
                      <span className="font-serif-display text-3xl text-[#c9a961] font-semibold tracking-wider">
                        {initials(a.name)}
                      </span>
                    </div>
                    <div className="mt-4 h-[1px] w-10 bg-[#c9a961] mx-auto" />
                    <div className="mt-3 text-[10px] uppercase tracking-[0.3em] text-[#c9a961]/90 font-semibold">
                      Advocate
                    </div>
                  </div>

                  {/* Hover bio overlay */}
                  <div className="absolute inset-0 bg-[#0a1428]/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-5 flex flex-col justify-center">
                    <p className="text-white/95 text-xs leading-relaxed text-center">
                      {a.bio}
                    </p>
                    <div className="flex items-center justify-center gap-2 mt-4">
                      <a
                        href="#"
                        className="w-7 h-7 rounded-full bg-[#c9a961] hover:bg-white text-[#0e1b34] flex items-center justify-center"
                      >
                        <Linkedin size={13} />
                      </a>
                      <a
                        href="#"
                        className="w-7 h-7 rounded-full bg-[#c9a961] hover:bg-white text-[#0e1b34] flex items-center justify-center"
                      >
                        <Mail size={13} />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="p-4 text-center border-t border-neutral-100">
                  <h4 className="font-serif-display text-[#0e1b34] text-lg font-semibold">
                    {a.name}
                  </h4>
                  <p className="text-[#b28e42] text-[11px] uppercase tracking-[0.2em] mt-1 font-semibold">
                    {a.role}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
